// extracted by mini-css-extract-plugin
module.exports = {"popupAd":"style_popupAd__QW_60","popupAdInner":"style_popupAdInner__VDpAu","count":"style_count__S8Lf7","adHeader":"style_adHeader__6uHLy","closeBtn":"style_closeBtn__UVslq"};